import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

/**
 * Forms that are on screen right now and named in the UI catalog's `forms`.
 *
 * Filled by `[alAgentForm]` (agent-form.directive.ts). The agent may later
 * prefill such a form — never submit it; saving stays the user's click.
 * Only ids are ever sent to the agent, never field values.
 */
@Injectable({ providedIn: 'root' })
export class AgentFormRegistry {
  private readonly forms = new Map<string, () => FormGroup | null>();

  register(id: string, form: () => FormGroup | null): () => void {
    this.forms.set(id, form);
    return () => {
      if (this.forms.get(id) === form) this.forms.delete(id);
    };
  }

  get(id: string): FormGroup | null {
    return this.forms.get(id)?.() ?? null;
  }

  ids(): string[] {
    return [...this.forms.keys()].filter((id) => this.get(id) !== null).sort();
  }
}
